import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoJmc: CultureInfo = {
  name: 'jmc',
  displayName: 'Kimachame',
  iso3LanguageCode: 'jmc',
  iso2LanguageCode: 'jmc',
  ietfLanguageTag: 'jmc',
  parent: null
};
